import TreatmentTypeSelect from './TreatmentTypeSelect'

export default TreatmentTypeSelect
